import { useEffect, useState } from 'react';

import { TextField, CircularProgress } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import useDebouncedEffect from 'hooks/useDebouncedEffect';

import { FaSearch } from 'react-icons/fa';
import {
  Card,
  Col,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from 'reactstrap';
import api from 'services/api';
import { iMaterial } from 'views/pages/Materiais';

interface Props {
  descricao?: string;
  children?: any;
  handleSelecionarItem: (itemDomsge: iAutoCompleteItem | null) => void;
  hideTitle?: boolean;
  maxWidth?: string;
  noAutoFocus?: boolean;
  emprCodigo?: string | undefined;
  geral?: boolean;
}

export interface iAutoCompleteItem {
  id: number;
  codigo: string;
  descricao: string;
}

export default function AutocompleteItem({
  descricao,
  children,
  handleSelecionarItem,
  hideTitle,
  maxWidth,
  noAutoFocus,
  emprCodigo,
  geral,
}: Props): JSX.Element {
  const [loadingItens, setLoadingItens] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState([] as iAutoCompleteItem[]);
  const [open, setOpen] = useState(false);
  const [itemSelecionado, setItemSelecionado] =
    useState<iAutoCompleteItem | null>(options[0]);
  const [listaMaterial, setListaMaterial] = useState([] as iMaterial[]);

  async function carregarDados() {
    const response = await api.get('/material');

    const lista = response.data as iMaterial[];

    setListaMaterial(lista.filter(item => item.isAtivo));
  }

  useEffect(() => {
    carregarDados();
  }, []);

  useDebouncedEffect(
    () => {
      let active = true;

      if (!open || loadingItens || inputValue.length < 3) {
        return undefined;
      }

      (async () => {
        try {
          setLoadingItens(true);

          const novaLista = listaMaterial.filter(item => {
            return (
              // Sap
              /* String(item.codigoSap)
                .toUpperCase()
                .includes(inputValue.toUpperCase()) || */
              String(item.descricao)
                .toUpperCase()
                .includes(inputValue.toUpperCase()) ||
              String(item.diteCodigo)
                .toUpperCase()
                .includes(inputValue.toUpperCase())
            );
          });

          setOptions(
            novaLista.map(item => {
              return {
                id: item.id,
                // codigo: item.codigoSap ?? item.diteCodigo, //SAP
                codigo: item.diteCodigo,
                descricao: item.descricao,
              };
            }) as iAutoCompleteItem[],
          );

          // Modificado temporariamente. Será deixado dinâmico na sprint 44
          /* const codigoEmpresa = emprCodigo !== '' ? emprCodigo : '710';

          const response = await api.get(`/integracao/item`, {
            params: {
              search: inputValue,
              emprCodigo: codigoEmpresa ?? '',
              geral,
            },
          });

          console.log(response.data);

          if (active) {
            setOptions(response.data);
          } */
        } finally {
          setLoadingItens(false);
        }
      })();

      return () => {
        active = false;
      };
    },
    1000,
    [inputValue],
  );

  useEffect(() => {
    if (!itemSelecionado) {
      setInputValue('');
    }

    setLoadingItens(false);
    setOpen(false);
    setOptions([]);
  }, [itemSelecionado]);

  return (
    <Card className="shadow mt-3 mb-1">
      <Col className="mt-4">
        <FormGroup className="mb-4">
          {!hideTitle && (
            <h5 className="mb-3">
              {descricao ? `${descricao} | ` : ''} Vincular item
            </h5>
          )}

          <InputGroup className="input-group-alternative">
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <FaSearch />
              </InputGroupText>
            </InputGroupAddon>

            <Autocomplete
              className="mt-1"
              style={{ maxWidth: maxWidth || '51vw' }}
              fullWidth
              size="small"
              open={open}
              options={options}
              loading={loadingItens}
              inputValue={inputValue}
              onOpen={() => {
                setOpen(true);
              }}
              getOptionSelected={(option: iAutoCompleteItem, value) =>
                option.id === value.id
              }
              getOptionLabel={option =>
                option?.codigo ? `${option.codigo} - ${option.descricao}` : ''
              }
              loadingText="Carregando..."
              noOptionsText="Nada encontrado"
              value={itemSelecionado}
              onChange={(_, itemDomsge) => {
                setItemSelecionado(itemDomsge);
                handleSelecionarItem(itemDomsge);
              }}
              onInputChange={(_, newInputValue) => {
                if (!newInputValue) return;

                setInputValue(newInputValue);
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  inputRef={input => input && !noAutoFocus && input.focus()}
                  size="small"
                  label="Pesquise um item..."
                  variant="outlined"
                  InputLabelProps={{ style: { fontSize: 13 } }}
                  InputProps={{
                    ...params.InputProps,
                    style: { fontSize: 13 },
                    endAdornment: (
                      <>
                        {loadingItens ? (
                          <CircularProgress color="inherit" size={15} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />

            {children}
          </InputGroup>
        </FormGroup>
      </Col>
    </Card>
  );
}
